<div class="col px-lg-5 px-2">
	<app-nav-prestation
		class="row py-5"
		[addable]="isAddable"
		(addEvent)="openModalAjout()"
	></app-nav-prestation>

	<!-- <div class="row mb-5 d-flex justify-content-start">
		<button
			*ngIf="isAddable"
			class="col-lg-2 col-5 my-2 mx-2 btn theme-green-button"
			(click)="openModalAjout()"
		>
			<i class="fs-5 bi bi-plus-lg" aria-hidden="true"></i> Ajouter
		</button>
	</div> -->

	<div class="my-3">
		<div class="row my-4">
			<pagination-controls
				class="d-flex justify-content-center"
				(pageChange)="currentPage = $event"
				previousLabel="Précédent"
				nextLabel="Suivant"
			>
			</pagination-controls>
			<div class="d-flex justify-content-center">
				<label class="form-label mt-2 mx-2">Elements par page</label>
				<div class="">
					<select
						[(ngModel)]="itemsPerPage"
						#ctrl="ngModel"
						(change)="currentPage = 1"
						[ngModelOptions]="{ standalone: true }"
						class="form-select"
					>
						<option [value]="5">5</option>
						<option *ngIf="prestations?.length >= 5" [value]="10">10</option>
						<option *ngIf="prestations?.length >= 10" [value]="25">25</option>
						<option *ngIf="prestations?.length >= 25" [value]="50">50</option>
						<option *ngIf="prestations?.length >= 50" [value]="100">100</option>
					</select>
				</div>
			</div>
		</div>
		<div class="my-2">
			<div class="row mt-4">
				<div class="col-2 ms-lg-auto">
					<div class="dropdown">
						<a
							class="btn btn-secondary dropdown-toggle"
							role="button"
							id="dropdownFilter"
							data-bs-toggle="dropdown"
							data-bs-auto-close="outside"
							aria-expanded="false"
						>
							<i class="bi bi-filter" aria-hidden="true"></i> Filtrer
						</a>
						<div
							class="dropdown-menu px-3 py-3"
							aria-labelledby="dropdownFilter"
							id="menuFilter"
						>
							<!-- <div class="row">
								<span class="theme-main-color form-label">Type(s) :</span>
								<div class="">
									<div
										*ngFor="let type of types | keyvalue"
										class="form-check"
									>
										<input
											(change)="changeTypesFilter($event, type.key)"
											class="form-check-input"
											type="checkbox"
											value="{{ type.key }}"
											id="dd{{ type.key }}"
										/>
										<label
											class="form-check-label"
											for="dd{{ type.key }}"
										>
											{{ type.value }}
										</label>
									</div>
								</div>
							</div> -->
						</div>
					</div>
				</div>

				<div class="col-lg-3 col-12">
					<div class="input-group">
						<span class="input-group-text bg-transparent"
							><i class="bi bi-search" aria-hidden="true"></i
						></span>
						<input
							type="text"
							class="form-control border-start-0"
							placeholder="Rechercher un élément..."
							[(ngModel)]="searchedText"
						/>
					</div>
				</div>
			</div>
		</div>

		<div class="row mt-4 mb-1">
			<div class="col-1">
				<span
					class="hand-cursor fw-bold"
					>Statut
				</span>
			</div>
			<div class="col-2 d-flex justify-content-around">
				<span
					class="hand-cursor fw-bold flex-grow-1 text-center"
					>Canal de communication
				</span>
			</div>
			<div class="col-2 d-flex justify-content-around">
				<span
					class="hand-cursor fw-bold flex-grow-1 text-center"
					>Date de reception de la demande
				</span>
			</div>
			<div class="col-2 fw-bold">
				<span
					class="hand-cursor fw-bold flex-grow-1 text-center"
					(click)="sortChange('dateLimite')"
					>Date de l'AR
				</span>
			</div>
			<div class="col-2 fw-bold">
				<span
					class="hand-cursor fw-bold flex-grow-1 text-center"
					>Prescripteur
				</span>
			</div>
			<div class="col-2 fw-bold">
				<span
					class="hand-cursor fw-bold flex-grow-1 text-center"
					>Statut de bénéficiaire
				</span>
			</div>
		</div>

		
		<div class="mt-4" *ngIf="isListingLoading">
			<app-loading></app-loading>
		</div>

		<!-- DEBUT DU LISTING -->
		<div *ngIf="!isListingLoading" class="mt-4">
			<div
				*ngFor="
					let prestation of prestations
						| paginate
							: {
									itemsPerPage: itemsPerPage,
									currentPage: currentPage
							  }
						| orderBy: sortType:sortOrder:['date', 'readyTime', 'dueTime']
				"
				class="row my-1 pt-3 pb-1 rounded rounded-3"
			>
				<span class="col-lg-1 col-12">
					<span class="fw-bold" *ngIf="isMobile">Statut: </span>
					{{
						PrestationStatutStringEnum[prestation.statut]
					}}
				</span>	
				<span class="col-lg-2 col-12">
					<span class="flex-grow-1 text-lg-center">
						<span *ngIf="prestation.canalCommunication">
							<span class="fw-bold" *ngIf="isMobile">Canal: </span>
							{{
								prestation.canalCommunication?.name
							}}
						</span>
					</span>
				</span>		  	
				<span [ngClass]="{ row: isMobile }" class="col-lg-2 d-flex">
					<span class="flex-grow-1 text-lg-center">
						<span class="fw-bold" *ngIf="isMobile">Date: </span>
						{{ prestation?.dateDebut | date: 'dd/MM/yy HH:mm' }}
					</span>
				</span>
				<span class="col-lg-2 col-12">
					<span class="flex-grow-1 text-lg-center">
						<span class="fw-bold" *ngIf="isMobile">Date: </span>
						{{ prestation?.dateAr | date: 'dd/MM/yy HH:mm' }}
					</span>
				</span>
				<span class="col-lg-2 col-12">
					<span class="flex-grow-1 text-lg-center">
						<span class="fw-bold" *ngIf="isMobile">Prescripteur: </span>
						{{
							prestation.prescripteur?.nomStructure
						}}
					</span>
				</span>
				<div class="col-lg-2">
					<div class="d-flex">
						<span class="flex-grow-1"
							><span *ngIf="prestation.beneficiaire">
								<span class="fw-bold" *ngIf="isMobile">Statut de bénéficiaire: </span>
								{{
									StatutBeneficiaireStringEnum[prestation.statutBeneficiaire]
								}}
							</span></span
						>
						<i
							class="fs-4 bi bi-caret-right-fill mb-1"
							aria-hidden="true"
							[routerLink]="['/prestation/infosas', prestation?.id]"
							role="button"
						></i>
					</div>
				</div>
			</div>
		</div>

		<div class="row my-4">
			<pagination-controls
				class="d-flex justify-content-center"
				(pageChange)="currentPage = $event"
				previousLabel="Précédent"
				nextLabel="Suivant"
			>
			</pagination-controls>
			<div class="d-flex justify-content-center">
				<label class="form-label mt-2 mx-2">Elements par page</label>
				<div class="">
					<select
						[(ngModel)]="itemsPerPage"
						#ctrl="ngModel"
						(change)="currentPage = 1"
						[ngModelOptions]="{ standalone: true }"
						class="form-select"
					>
						<option [value]="5">5</option>
						<option *ngIf="prestations?.length >= 5" [value]="10">10</option>
						<option *ngIf="prestations?.length >= 10" [value]="25">25</option>
						<option *ngIf="prestations?.length >= 25" [value]="50">50</option>
						<option *ngIf="prestations?.length >= 50" [value]="100">100</option>
					</select>
				</div>
			</div>
		</div>
	</div>
</div>

<!-- <ng-template #modalSuppressionMultiple>
	<div class="modal-header">
		<h4 class="modal-title pull-left">
			Suppression de {{ labelInterventionPluralized }}
		</h4>
		<button
			type="button"
			class="btn-close close pull-right"
			aria-label="Close"
			(click)="modalSuppressionMultipleRef?.hide()"
		>
			<span aria-hidden="true" class="visually-hidden">&times;</span>
		</button>
	</div>
	<div class="modal-body">
		<div class="row my-2">
			<div class="col-5">
				<span class="theme-main-color">Période :</span>
			</div>
			<div class="col">
				<span class="theme-main-color"
					>Du
					{{
						dateRange.value[0].getDate() +
							' ' +
							monthsFr[dateRange.value[0].getMonth()] +
							'
					' +
							dateRange.value[0].getFullYear()
					}}</span
				>
				<span class="mx-2 theme-main-color"
					>au
					{{
						dateRange.value[1].getDate() +
							' ' +
							monthsFr[dateRange.value[1].getMonth()] +
							'
					' +
							dateRange.value[1].getFullYear()
					}}</span
				>
			</div>
		</div>
		<div class="row my-2">
			<div class="col-5">
				<span class="theme-main-color">Compétences sélectionnées :</span>
			</div>
			<div class="col">
				<span
					class="theme-main-color"
					*ngIf="
						selectedCompetences.length === 0 || selectedCompetences.length === 3
					"
					>Toutes</span
				>
				<div
					*ngIf="
						!(
							selectedCompetences.length === 0 ||
							selectedCompetences.length === 3
						)
					"
				>
					<span
						class="theme-main-color"
						*ngFor="let comp of selectedCompetences"
						class="me-2"
						>{{ competences[comp] }}</span
					>
				</div>
			</div>
		</div>
		<div class="row my-2">
			<div class="col-5">
				<span class="theme-main-color">Total :</span>
			</div>
			<div class="col">
				<span class="theme-main-color"
					>{{ listSelectedMissionRequestDelete.length }}
					{{ labelInterventionPluralized }}</span
				>
			</div>
		</div>
		<div class="row mt-4 mb-2">
			<span class="theme-main-color"
				>Si ces informations vous semblent correctes valider la suppression
				<span class="theme-red-color fw-bold"
					>(cette action est irréversible)</span
				></span
			>
		</div>
	</div>
	<div class="modal-footer">
		<button
			type="button"
			class="btn theme-main-color-button"
			data-bs-dismiss="modal"
			(click)="modalSuppressionMultipleRef?.hide()"
		>
			Annuler
		</button>
		<button
			type="button"
			class="btn theme-red-button"
			(click)="validateDeleteListSelectedMission()"
			[disabled]="isBtnValidateDeleteListClicked"
		>
			Supprimer
		</button>
	</div>
</ng-template> -->

<!-- <ng-template #modalSuppressionAssignedToPlanning>
	<div class="modal-header">
		<h4 class="modal-title text-center">
			Une ou plusieurs {{ labelInterventionPluralized }} sont affectées dans le
			planning, voulez-vous vraiment les supprimer ?
		</h4>
		<button
			type="button"
			class="btn-close close pull-right"
			aria-label="Close"
			(click)="modalSuppressionAssignedToPlanningRef?.hide()"
		>
			<span aria-hidden="true" class="visually-hidden">&times;</span>
		</button>
	</div>
	<div class="modal-body">
		<div class="d-flex justify-content-evenly">
			<button
				class="btn theme-main-color-button"
				(click)="modalSuppressionAssignedToPlanningRef?.hide()"
			>
				Non
			</button>
			<button
				class="btn theme-red-button"
				(click)="
					deleteMissionsAssignedToPlanning = true;
					modalSuppressionAssignedToPlanningRef?.hide()
				"
			>
				Oui
			</button>
		</div>
	</div>
</ng-template> -->
